// Module-level bridge that lets non-React code (Apollo error link, etc.)
// surface user-facing messages via the existing NotificationProvider Snackbar.

type Handler = (message: string) => void;

let errorHandler: Handler | null = null;

export function setErrorHandler(handler: Handler | null): void {
  errorHandler = handler;
}

export function emitError(message: string): void {
  errorHandler?.(message);
}
